export default __webpack_public_path__ + "static/equilibre_avatar_aurelien_souppez-440d25d0c960ed7bb801e064effc7629.png";